var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VEmojiPicker',{class:_vm.pickerClasses,attrs:{"labelSearch":"Search","customEmojis":_vm.customEmojiList,"customCategories":_vm.customCategoryList,"continuousList":true},on:{"select":function($event){return _vm.$emit('select', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }